import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Sprout } from 'lucide-react'
import { useSignup } from '../hooks/useSignup'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { AuthPageShell, AUTH_INPUT_CLASS } from '@/components/auth/AuthPageShell'

const Signup = (): JSX.Element => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const { signup, error, isLoading } = useSignup()

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault()
    await signup(email, password, firstName, lastName)
  }

  return (
    <AuthPageShell
      wide
      icon={<Sprout className="size-6" aria-hidden />}
      title="Create your account"
      description="Set up Intelli Gardener to track environments, devices, and gardens."
      onSubmit={handleSubmit}
      error={error}
      isLoading={isLoading}
      submitIdleLabel="Create account"
      submitLoadingLabel="Creating account…"
      footer={
        <p className="text-center text-base leading-relaxed text-zinc-300">
          Already have an account?{' '}
          <Link
            to="/login"
            className="font-semibold text-emerald-400 no-underline hover:text-emerald-300 hover:underline"
          >
            Sign in
          </Link>
        </p>
      }
    >
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div className="space-y-2">
          <Label htmlFor="firstName" className="text-sm font-medium text-zinc-200">
            First name
          </Label>
          <Input
            id="firstName"
            type="text"
            autoComplete="given-name"
            placeholder="Alex"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            className={AUTH_INPUT_CLASS}
            required
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="lastName" className="text-sm font-medium text-zinc-200">
            Last name
          </Label>
          <Input
            id="lastName"
            type="text"
            autoComplete="family-name"
            placeholder="Rivera"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            className={AUTH_INPUT_CLASS}
            required
          />
        </div>
      </div>
      <div className="space-y-2">
        <Label htmlFor="signup-email" className="text-sm font-medium text-zinc-200">
          Email
        </Label>
        <Input
          id="signup-email"
          type="email"
          autoComplete="email"
          placeholder="you@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className={AUTH_INPUT_CLASS}
          required
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="signup-password" className="text-sm font-medium text-zinc-200">
          Password
        </Label>
        <Input
          id="signup-password"
          type="password"
          autoComplete="new-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className={AUTH_INPUT_CLASS}
          required
        />
      </div>
    </AuthPageShell>
  )
}

export default Signup
